import { render, staticRenderFns } from "./regionForm.vue?vue&type=template&id=83f785fa&scoped=true"
import script from "./regionForm.vue?vue&type=script&lang=js"
export * from "./regionForm.vue?vue&type=script&lang=js"
import style0 from "./regionForm.vue?vue&type=style&index=0&id=83f785fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f785fa",
  null
  
)

export default component.exports